<template>
  <!-- TODO ¿Algo más bonico y quitar la redirección? -->
  <h1>404 Not found</h1>
</template>

<script>
export default {
  name: 'NotFoundPage',
  created() {
    this.$router.push({ name: '/' });
  }
};
</script>
